import styled from "styled-components";

export const Request990Wrapper = styled.div`
  background: var(--modal-grey);
  border-radius: 15px;
  box-shadow: 2px 2px 6px #0000003B;
  padding: 57px 82px 120px 82px;
`